 
document.addEventListener('DOMContentLoaded', async function () { 
  const pathParts = window.location.pathname.split('/');
  const productHandle = window.location.pathname.split('/').filter(Boolean).pop();
  let currentVariant = null;
  const check_wallet_airpod = productHandle.includes("airpods") || productHandle.includes("wallet");
  if(!check_wallet_airpod)return;
  // handle products images 
  // 🗂️ Cache all product images by their `alt` tag (unique only)
  window.PRODUCT_IMAGES_BY_ALT = {};

  document.querySelectorAll('.main-product-image-swiper .swiper-slide').forEach(slide => {
    // Skip Swiper’s duplicated loop slides
    if (slide.classList.contains('swiper-slide-duplicate')) return;

    const alt = slide.getAttribute('data-alt')?.trim().toLowerCase() || 'default';

    if (!window.PRODUCT_IMAGES_BY_ALT[alt]) {
      window.PRODUCT_IMAGES_BY_ALT[alt] = [];
    }

    // Prevent same slide HTML from being pushed twice
    if (!window.PRODUCT_IMAGES_BY_ALT[alt].some(html => html.includes(slide.getAttribute('data-src')))) {
      window.PRODUCT_IMAGES_BY_ALT[alt].push(slide.outerHTML);
    }
  });

  // Also store a combined “all” version without duplicates
  const uniqueSlides = Array.from(
    document.querySelectorAll('.main-product-image-swiper .swiper-slide:not(.swiper-slide-duplicate)')
  ).map(slide => slide.outerHTML);

  window.PRODUCT_IMAGES_BY_ALT['all'] = uniqueSlides.join('');

  // console.log('✅ Cached unique product images by alt:', window.PRODUCT_IMAGES_BY_ALT);

 
  
  const productData = await fetch(`/products/${productHandle}.js`).then(res => res.json());

  const variants = productData.variants;
 
  function findVariantBySelections(selections) {
    return variants.find(v => {
      return v.options.every((opt, i) => opt === selections[i]);
    });
  }
 
  const optionInputs = document.querySelectorAll('.single-option-selector');
  const optionGroups = {};
 
  optionInputs.forEach(input => {
    const name = input.name;
    if (!optionGroups[name]) optionGroups[name] = [];
    optionGroups[name].push(input);
  });
 
  Object.keys(optionGroups).forEach(name => {
    optionGroups[name].forEach(input => {
      const value = input.value;
      const available = variants.some(v => v.options.includes(value) && v.available);
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!available) {
        input.disabled = true;
        label.classList.add('disabled');
      } else {
        input.disabled = false;
        label.classList.remove('disabled');
      }
    });
  });
 
  function updateVariantSelection() {
    const selections = Object.keys(optionGroups).map(name => {
      const selected = document.querySelector(`input[name="${name}"]:checked`);
      return selected ? selected.value : null;
    });

    const variant = findVariantBySelections(selections);
    if (!variant) return;
    currentVariant = variant;

    const productSelect = document.querySelector(".product__select");
    if (productSelect) {
      productSelect.querySelectorAll("option").forEach(opt => {
        opt.selected = opt.value == currentVariant.id;
      });
    }

    const newUrl = `${window.location.pathname}?variant=${variant.id}`;
    window.history.replaceState(null, '', newUrl);

    // Highlight labels
    document.querySelectorAll('.option-items label').forEach(l => l.classList.remove('selected'));
    Object.keys(optionGroups).forEach(name => {
      const selected = document.querySelector(`input[name="${name}"]:checked`);
      if (selected) document.querySelector(`label[for="${selected.id}"]`)?.classList.add('selected');
    });

    // 🎨 Detect selected fabric
    const selectedFabric = selections.find(v => v && (v.toLowerCase().includes('gold') || v.toLowerCase().includes('silber')));
    // console.log('🎨 Selected fabric:', selectedFabric);

    // 🔔 Update Add to Cart button based on availability
    let addToCartBtn = document.querySelector('.add-to-cart-form-button');

    if (addToCartBtn) {
      const parent = addToCartBtn.parentNode;

      // Named function for Notify Me
      const notifyMeHandler = (e) => {
        e.preventDefault();
        document.querySelector('.klaviyo-notify-me-custom .kl-button-n')?.click();
      };

      if (!currentVariant.available) {
        // Unavailable variant → Notify Me
        const cloneBtn = addToCartBtn.cloneNode(true); // remove old listeners
        parent.replaceChild(cloneBtn, addToCartBtn);
        addToCartBtn = cloneBtn;

        addToCartBtn.textContent = 'E-Mail wenn verfügbar';
        addToCartBtn.classList.add('notify-me');
        addToCartBtn.addEventListener('click', notifyMeHandler);

      } else {
        // Available variant → only replace/attach if previous variant was unavailable
        if (addToCartBtn.classList.contains('notify-me')) {
          const newButton = document.createElement('div');
          newButton.className = 'add-to-cart add-to-cart-form-button';
          newButton.setAttribute('data-text', 'In den Warenkorb');
          newButton.textContent = 'Add to Cart';

          parent.replaceChild(newButton, addToCartBtn);
          addToCartBtn = newButton;

          // Attach the original theme Add to Cart event
          addToCartBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            const select = document.querySelector(".product__select");
            if (select) {
              Array.from(select.options).forEach((option) => {
                if (option.selected) {
                  const variant = option.getAttribute("value");

                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: variant, quantity: 1 }),
                  })
                    .then((response) => {
                      if (!response.ok) throw new Error(`Error: ${response.status}`);
                      return response.json();
                    })
                    .then((data) => {
                      if (typeof window.preCardOpenHandler === 'function') window.preCardOpenHandler();
                    })
                    .catch((error) => console.error("Error adding product to cart:", error));
                }
              });
            }
          });
        }
      }
    }

    // 🖼️ Swiper (mobile)
    const wrapper = document.querySelector('.main-product-image-swiper .swiper-wrapper');
    if (wrapper && window.mainProductImage) {
      const scrollTop = window.scrollY;
      window.mainProductImage.removeAllSlides();

      const fabricKey = selectedFabric ? selectedFabric.toLowerCase() : 'all';
      const slidesHtml = window.PRODUCT_IMAGES_BY_ALT[fabricKey] || [];

      slidesHtml.forEach(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html.trim();
        const slideEl = tempDiv.firstChild;
        window.mainProductImage.appendSlide(slideEl);
      });

      const paginationEl = document.querySelector('.main-product-pagination');
      if (paginationEl) paginationEl.innerHTML = '';
      window.mainProductImage.update();
      setTimeout(() => {
        window.mainProductImage.pagination.render();
        window.mainProductImage.pagination.update(); 
      }, 50);

      window.requestAnimationFrame(() => {
        window.scrollTo({ top: scrollTop, behavior: 'auto' });
        window.mainProductImage.slideToLoop(0, 0);
      });
    }

    // 🖥️ Desktop (non-swiper) images — show only 4 images + toggle "Show more"
    if (window.innerWidth >= 900) {
      const desktopImagesContainer = document.querySelector('.main-product__images .images');
      const showMoreBtn = document.querySelector('.main-product__images .show-more-button');

      if (desktopImagesContainer) {
        const fabricKeyDesktop = selectedFabric ? selectedFabric.toLowerCase() : 'all';
        const imagesHtmlAll = window.PRODUCT_IMAGES_BY_ALT[fabricKeyDesktop] || [];

        // Store images globally per fabric for toggling later
        window.CURRENT_DESKTOP_IMAGES = {
          key: fabricKeyDesktop,
          all: imagesHtmlAll,
          showingAll: false
        };

        // Display only 4 initially
        const imagesHtml = imagesHtmlAll.slice(0, 4);

        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';

        desktopImagesContainer.classList.add('updating');
        desktopImagesContainer.innerHTML = imagesHtml.join('');

        const newImages = desktopImagesContainer.querySelectorAll('img');
        const imagePromises = Array.from(newImages).map(
          img => img.complete ? Promise.resolve() : new Promise(res => img.onload = img.onerror = res)
        );

        Promise.all(imagePromises).then(() => {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          document.body.style.width = '';
          window.scrollTo(0, scrollY);
          desktopImagesContainer.classList.remove('updating');

          if (showMoreBtn) {
            if (imagesHtmlAll.length > 4) {
              showMoreBtn.classList.remove('hide-elem');
            } else {
              showMoreBtn.classList.add('hide-elem');
            }
            showMoreBtn.classList.remove('show-2nd-text');
          }

          // console.log(`🖼️ Desktop images updated for "${fabricKeyDesktop}" (${imagesHtml.length} shown of ${imagesHtmlAll.length})`);
        });
      }

      // Handle Show More / Less button
      if (showMoreBtn) {
        showMoreBtn.onclick = () => {
          if (!window.CURRENT_DESKTOP_IMAGES) return;

          const { all, showingAll } = window.CURRENT_DESKTOP_IMAGES;
          const container = document.querySelector('.main-product__images .images');
          if (!container) return;

          if (!showingAll) {
            container.innerHTML = all.join('');
            showMoreBtn.classList.add('show-2nd-text');
            window.CURRENT_DESKTOP_IMAGES.showingAll = true;
          } else {
            container.innerHTML = all.slice(0, 4).join('');
            showMoreBtn.classList.remove('show-2nd-text');
            window.CURRENT_DESKTOP_IMAGES.showingAll = false;
          }
        };
      }
    }
  }

  // Enable all variant options on page load
  document.querySelectorAll('.option-items input.single-option-selector').forEach(input => {
    input.disabled = false; // Remove the disabled attribute
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) {
      label.classList.remove('disabled'); // Remove the disabled class
    }
  });
  // Attach to option inputs
  optionInputs.forEach(input => {
    input.addEventListener('change', updateVariantSelection);
  });

 
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');

  let initialVariant = variantId
    ? variants.find(v => v.id == variantId)
    : variants.find(v => v.available);

  if (initialVariant) {
    initialVariant.options.forEach((val, i) => {
      const inputs = Object.values(optionGroups)[i];
      const input = inputs.find(el => el.value === val);
      if (input) {
        input.checked = true;
      }
    });
    updateVariantSelection();
  }

// 🛒 Update header cart count after add to cart
  function updateCartCountBadge() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
    const cartCountEl = document.querySelector('.header__cart .cart-count');
    if (cartCountEl) {
        cartCountEl.textContent = cart.item_count;
    }
    })
    .catch(err => console.error('❌ Error updating cart count:', err));
  }
  function handle_Add_toCart_event_attach(){
    const addToCartFormButton = document.querySelector('.add-to-cart-form-button');

    if (addToCartFormButton) {
      addToCartFormButton.addEventListener('click', () => {
        // Wait a short moment to let Shopify update cart, then refresh badge
        setTimeout(updateCartCountBadge, 800);
      });
    }
    if (typeof window.preCardOpenHandler === 'function') {
      const originalPreCart = window.preCardOpenHandler;
      window.preCardOpenHandler = function() {
      updateCartCountBadge();
      originalPreCart();
      };
    }
  }
  handle_Add_toCart_event_attach()


  let lastIsMobile = window.innerWidth < 900;
  let resizeTimeout = null;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const isMobile = window.innerWidth < 900;
      if (isMobile !== lastIsMobile) {
        lastIsMobile = isMobile;
        updateVariantSelection(); // re-init swiper or desktop grid
      }
    }, 200); // wait 200 ms after resizing stops
  });
}); 
